var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"md":"12","cols":"12"}},[_c('WarningAlert',[_vm._v(" "+_vm._s(_vm.$t("common.access_denied_age_18"))+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }